import { Dialog, makeStyles, Paper, Theme } from '@material-ui/core';

import { Content, Header, Page } from '@backstage/core-components';
import { BACKSTAGE_ASK_A_FRIEND_URL, PATH_MAPPINGS } from '../../constants';
import { LinkButton } from '../LinkButton';

const useStyles = makeStyles((theme: Theme) => ({
  bar: {
    padding: theme.spacing(2),
    backgroundColor: 'rgba(255, 127, 74, 0.1)', // 90% transparent orange-red tint
  },
  dialog: {
    height: 'auto',
    width: 'auto',
  },
  linkList: {
    listStyleType: 'none',
    paddingLeft: 0,
    margin: 0,
  },
}));

interface HelpPageProps {
  open?: boolean;
  onClose?: () => void;
  currentLocation: string;
}

export const HelpPage = ({ open = false, onClose, currentLocation }: HelpPageProps) => {
  const classes = useStyles();

  const currentMapping = (() => {
    // Sort patterns by length (longest first) to match most specific patterns first
    const sortedPatterns = Object.entries(PATH_MAPPINGS)
      .filter(([pattern]) => pattern !== 'default')
      .sort(([a], [b]) => b.length - a.length);

    // Find the first pattern that matches the current location
    for (const [pattern, mapping] of sortedPatterns) {
      const regex = new RegExp(pattern);

      if (regex.test(currentLocation)) {
        return mapping;
      }

      if (pattern === currentLocation) {
        return mapping;
      }
    }

    // Return default if no pattern matches
    return PATH_MAPPINGS.default;
  })();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <Page themeId="home">
        <Header title="Help" />
        <Content>
          <p>
            Check out the existing <LinkButton url={currentMapping?.documentationUrl}>🗂️ Documentation</LinkButton> on
            the topic you need help with.
          </p>
          <p>
            You can also visit the <LinkButton url={BACKSTAGE_ASK_A_FRIEND_URL}>❓ Ask A Friend</LinkButton> channel in
            Microsoft Teams to connect with other users and developers to find additional support.
          </p>
          <Paper elevation={5} className={classes.bar}>
            You may also create a Jira ticket via the WSA Service Desk so that we may attend to your issue:
            <ul className={classes.linkList}>
              <li>
                <LinkButton url={currentMapping?.supportRequestUrl}>🆘 Create a Support Request</LinkButton>
              </li>
              <li>
                <LinkButton url={currentMapping?.supportIncidentUrl}>
                  🚨 Report an Incident (Something is Broken)
                </LinkButton>
              </li>
            </ul>
          </Paper>
        </Content>
      </Page>
    </Dialog>
  );
};
